import './App.css';
import Home from './components/Home';
import '@fortawesome/fontawesome-free/css/all.min.css';

function App() {
  return (
    <div className="App">
      <Home/>
    </div>
  );
}

export default App;
